import { render, staticRenderFns } from "./order-status-component.vue?vue&type=template&id=828d669a&scoped=true"
import script from "./order-status-component.vue?vue&type=script&lang=js"
export * from "./order-status-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828d669a",
  null
  
)

export default component.exports